import React, { Suspense } from "react";
import { AppLoader } from "../../splash";

export default function SuspenseComponent({ children }) {
  return <Suspense fallback={<AppLoader />}>{children}</Suspense>;
}
